import type { GridFilterModel } from "@mui/x-data-grid-premium";

export const filterModelWithoutIds = (model: GridFilterModel) => {
  return {
    ...model,
    items: model.items.map(({ field, value, operator }) => ({
      field,
      value,
      operator,
    })),
  };
};
